// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnderlineOutlinedSvg from "@fishx/icons-svg/es/asn/UnderlineOutlined";
import FishxIcon from '../components/FishxIcon';

var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnderlineOutlinedSvg
  }));
};

UnderlineOutlined.displayName = 'UnderlineOutlined';
export default React.forwardRef(UnderlineOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UnderlineOutlined.js
// module id = 4299
// module chunks = 0